import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { track } from "@/lib/track";

export default function CampaignStart() {
  const [go, setGo] = useState(false);

  useEffect(() => {
    track("visit");
    const tmr = setTimeout(() => setGo(true), 60);
    return () => clearTimeout(tmr);
  }, []);

  if (go) return <Navigate to="/brands#contact" replace />;

  return (
    <div
      className="min-h-screen bg-[#faf8f5] flex items-center justify-center font-mono-spec text-sm text-slate-500"
      data-testid="campaign-start-redirect"
    >
      Weiterleitung …
    </div>
  );
}
